module.exports = __webpack_public_path__ + "static/media/02-_DSC0830.2d89d6db.jpg";